import React from 'react';


const ContactForm = () => {
    return (
        <div className='' >
            <div className='row'>
                <div className='col-md-6'>
                    <div className=''>
                        <label className='contact-form-label' htmlFor='name'>Name</label>
                        <input className='contact-form-input' type='text' placeholder='Enter your name' />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className=''>
                        <label className='contact-form-label' htmlFor='email'>Email</label>
                        <input className='contact-form-input' type='email' placeholder='Enter your email' />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className=''>
                        <label className='contact-form-label' htmlFor='phone'>Phone</label>
                        <input className='contact-form-input' type='text' placeholder='Enter your phone number' />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className=''>
                        <label className='contact-form-label' htmlFor='location'>Location</label>
                        <input className='contact-form-input' type='text' placeholder='Enter your location' />
                    </div>
                </div>
                <div className='col-md-12'>
                    <div className=''>
                        <label className='contact-form-label' htmlFor='message'>Message</label>
                        <textarea className='contact-form-textarea' cols={30} rows={6} name='message' id='message' placeholder='Enter your message' />
                    </div>
                </div>
                <div className='col-md-12'>
                    <div className='d-flex justify-content-start gap-3'>
                        <button className='renoxweb-blue-btn btn ' type='submit'>Submit</button>
                        <button className='renoxweb-white-btn' type='reset'>Reset</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactForm;